import * as Sentry from '@sentry/react';
import { isNetworkError } from '../api/apiClient';
import { getCurrentUser } from '../utils/currentUser';
import { getEnvironment, isDevEnv } from '../utils/environment';

export function initSentry() {
    if (!isDevEnv()) {
        Sentry.init(sentryConfig);
    }
}
const sentryConfig = {
    dsn: 'https://898daa460f4f9e165490588b70f0ccbf@o455099.ingest.us.sentry.io/4508257454391296',
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration(),
        Sentry.httpClientIntegration({
            // 5xx only — expected 4xx (auth, validation, not-found) would be
            // noise and error pages are already captured separately
            failedRequestStatusCodes: [[500, 599]],
            // only our API — third-party failures (analytics, fonts) would be noise
            failedRequestTargets: [
                /^https:\/\/app\.hustro\.com\/api/,
                /^https:\/\/stage\.o\.hustroapp\.com\/api/,
            ],
        }),
    ],
    environment: getEnvironment(),
    enableLogs: true,
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [
        'localhost',
        /^https:\/\/app\.hustro\.com\/api/,
        /^https:\/\/stage\.o\.hustroapp\.com\/api/,
    ],
    beforeSend(event: Sentry.ErrorEvent, hint: Sentry.EventHint) {
        // Transient network errors (offline, timeout) have a dedicated
        // retry UI and are not actionable — don't report them.
        if (isNetworkError(hint.originalException)) {
            return null;
        }
        // Safety net for events captured before setCurrentUser() ran — fills in
        // gaps without clobbering what the scope already knows.
        const { id, email } = getCurrentUser();
        if (id || email) {
            event.user = {
                ...event.user,
                id: event.user?.id ?? id,
                email: event.user?.email ?? email,
            };
        }
        return event;
    },

    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
};
